import { usePromotionLayout } from './hooks';
import { AnimationElement } from '../../../common/Animation';
import { PROMOTION_SECTION_ID } from '../../../../constants/nodeIds';
import { Layout } from '../../../ServicePickerWidget/Layout';
import { PromotionHeader } from '../PromotionHeader';
import { LoaderContainer } from '../../../Loader';
import { MoneySourceTabsContainer } from '../MoneySourceTabs';
import { WithoutServicesScreenContainer } from '../WithoutServicesScreen';
import { PromotionSectionContainer } from '../PromotionSection';
import * as React from 'react';

export interface IPromotionLayoutProps {
  isLoading: boolean;
}

export const PromotionLayout = ({ isLoading }: IPromotionLayoutProps) => {
  const { showServicesToggle, showNoServicesScreen, showMoneySourceWidget } = usePromotionLayout();

  return (
    <AnimationElement layout id={PROMOTION_SECTION_ID}>
      <Layout>
        <Layout.Title>
          <PromotionHeader showServicesToggle={showServicesToggle} />
        </Layout.Title>
        <Layout.Content>
          {isLoading ? (
            <LoaderContainer />
          ) : (
            <>
              {showMoneySourceWidget && (
                <AnimationElement layout="position">
                  <MoneySourceTabsContainer />
                </AnimationElement>
              )}
              <AnimationElement layout="position">
                {showNoServicesScreen ? <WithoutServicesScreenContainer /> : <PromotionSectionContainer />}
              </AnimationElement>
            </>
          )}
        </Layout.Content>
      </Layout>
    </AnimationElement>
  );
};
